import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BookingModel, BookingService, LayoutService, NavigationResolver, NavigationService, ActiveRentalService } from 'app-components';
import * as moment from 'moment';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { BookingErrorCode, ObjectTypeInfo, PageBase, PriceModel } from 't4core';

@Component({
    selector: 'app-create-booking',
    templateUrl: './create-booking.component.html',
    styleUrls: ['./create-booking.component.css'],
    standalone: false
})
export class CreateBookingComponent extends PageBase implements OnInit {
  public bookingState: BookingModel;
  public user: string;
  public requireVerification: boolean = false;
  public useSavedCard: boolean = true;
  public terms: boolean = false;
  public quarterFromNow: moment.Moment = moment().add(15, 'minutes');
  public hasBookingId: boolean = false;
  public currentPrice: PriceModel = new PriceModel();
  public addableProducts: ObjectTypeInfo[];
  public addonsFromPopup: ObjectTypeInfo[];

  constructor(private navigator: NavigationService, el: ElementRef, private appService: AppIntegrationService, private BookingDataService: BookingService, public dialog: MatDialog, public resolver: NavigationResolver, public layout: LayoutService, public appSettings: AppSettingsService, private rentalService: ActiveRentalService) {
    super(el);
  }

  ngOnInit(): void {
    this.bookingState = this.BookingDataService.getBookingState();
    this.createBooking();
  }

  public async createBooking(firstTry:boolean = true) {
    var validate = await this.BookingDataService.saveBooking(true, this.useSavedCard);
    if (validate.CustomerDenied) {
      return;
    }
    if (validate.AggregatedResult == BookingErrorCode.Valid) {
      await this.rentalService.setActiveRental(validate.BookingId);

      if (validate.RequirePayment) {
        this.navigator.executeCommand("Payment", { rentalId: validate.BookingId });
      }
      else {
          this.navigator.executeCommand("Next", { rentalId: validate.BookingId });
      }
    }
    else if (validate.AggregatedResult == BookingErrorCode.LocationNotOpen) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeNotOpenHead", "Invalid booking!", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeNotOpenMsg", "The location is not open for pickup at the specified pickup time.");
    }
    else if (validate.AggregatedResult == BookingErrorCode.ObjectUnavailable) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeObjectUnavailable", "Trailer Unavailable", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorUnavailableMsg", "The trailer you are trying to book has just been reserved by another user.");
   
      this.navigator.executeCommand("TrailerUnavailable")
    }
    else if (validate.AggregatedResult == BookingErrorCode.PeriodUnavailable) {
        // Inform the user about the situation
        var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorInvalidPeriod", "Invalid booking period", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorInvalidPeriodMsg", "The start and/or end time you have selected is not valid. Please review and correct them and try again.");
        this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 2048) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeCustomerIsBlocked2", "Account is blocked", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCustomerIsBlockedMsg3", "Your account number has been blocked for further rent. Please contact customer service.");
      this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 4096) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeMaxBookingsPerDay2", "Maximum bookings per day reached", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorMaxBookingsPerDayMsg2", "You have reached the maximum number of bookings on one day. Welcome back tomorrow!");
      this.back();
    }
    else if (validate.AggregatedResult != BookingErrorCode.Valid && validate.ErrorCode == 8192) {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfrimedBooking.BookingErrorCodeMaximumConcurrentBookings2", "Maximum number of concurrent bookings reached", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorMaximumConcurrentBookingsMsg2", "You have reached the maximum number of concurrent bookings. Please return the active bookings and try again.");
      this.back();
    }
    else {
      var x = await this.UI.alert("Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeHead", "Something went wrong!", "Intellitrailer.Booking.UnconfirmedBooking.BookingErrorCodeMsg", "Please try again, or contact support if the problem persists.");

      // Dead end! Log to insights!
      this.Insights.trackTrace("Dead end! CreateBooking", {
        result: validate.AggregatedResult,
        code: validate.ErrorCode,
        userInfo: JSON.stringify(this.BookingDataService?.Query?.Customer)
      });
    }
  }

  public async back() {
    this.navigator.back();
  }

}
